import * as Headless from '@headlessui/react';
import { clsx } from 'clsx';
import React from 'react';
import { toast } from 'react-toastify';

import { useActingAsEntity } from '../hooks/useActingAsEntity';
import { HealthcareEntitySearchList } from './healthcare-entity-search-list';

export const ActingAsEntityPill: React.FC = () => {
  const { actingAsEntity, setActingAsEntity, isStaff } = useActingAsEntity();

  if (!isStaff) return null;

  const isEmpty = !actingAsEntity;

  return (
    <Headless.Popover className="tw:relative">
      <Headless.PopoverButton
        className={clsx(
          'tw:inline-flex tw:items-center tw:gap-1.5 tw:px-3 tw:py-1 tw:text-sm tw:!rounded-lg tw:border tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-offset-1',
          isEmpty
            ? 'tw:bg-white/80 tw:text-brand-green-0 tw:border-zinc-300 tw:hover:bg-brand-green-2 tw:focus:ring-zinc-400'
            : 'tw:bg-amber-100 tw:text-amber-900 tw:border-amber-300 tw:hover:bg-amber-200 tw:focus:ring-amber-400'
        )}
      >
        {isEmpty ? (
          <>
            <i className="far fa-hospital" />
            <span>Select organization</span>
          </>
        ) : (
          <>
            <i className="far fa-hospital" />
            <span>
              Acting as: <strong>{actingAsEntity.name}</strong>
            </span>
          </>
        )}
        <i className="fas fa-chevron-down tw:text-xs tw:ml-1" />
      </Headless.PopoverButton>
      <Headless.PopoverPanel
        anchor="bottom end"
        className="tw:[--anchor-gap:8px] tw:z-50 tw:bg-white tw:rounded-lg tw:shadow-lg tw:ring-1 tw:ring-zinc-950/10 tw:focus:outline-none"
      >
        {({ close }) => (
          <HealthcareEntitySearchList
            /* eslint-disable-next-line jsx-a11y/no-autofocus */
            autoFocus
            selectedId={actingAsEntity?.id ?? null}
            showClear={!isEmpty}
            onSelect={(entity) => {
              setActingAsEntity(entity);
              close();
              toast.success(`Now acting as ${entity.name}`);
            }}
            onClear={() => {
              setActingAsEntity(null);
              close();
              toast.info('Cleared organization context');
            }}
          />
        )}
      </Headless.PopoverPanel>
    </Headless.Popover>
  );
};
